// extracted by mini-css-extract-plugin
export default {"container":"Featured_container__2Ik7M","emptyCardContainer":"Featured_emptyCardContainer__qbsNa"};